/**
 * Fibonacci 黄金螺旋球面均匀方向生成器。
 * 用于多次散射 secondOrder 模式的二次散射方向（CPU 生成后传入着色器 uniform 数组）。
 */

import type { Vec3 } from './raySphere'

/** 着色器中二次散射方向数组的上限（uniform vec3 uMSDirs[16]） */
export const MAX_MS_DIRS = 16

/** 黄金角（弧度）：2π·(1 - 1/φ) */
export const GOLDEN_ANGLE = 2.39996322972865332

/**
 * 生成 count 个近似均匀分布的球面单位方向。
 * 基于 Fibonacci 球体分布（黄金螺旋）。
 */
export function goldenSpiralDirections(count: number): Vec3[] {
  const dirs: Vec3[] = []
  for (let i = 0; i < count; i++) {
    // 沿 z 轴均匀分布的纬度角
    const phi = Math.acos(1 - (2 * (i + 0.5)) / count)
    const theta = GOLDEN_ANGLE * i
    const sp = Math.sin(phi)
    dirs.push([sp * Math.cos(theta), sp * Math.sin(theta), Math.cos(phi)])
  }
  return dirs
}
